import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
// components
import { regionSheetSx } from 'src/components/universe/Surface';
import { hairlineOf } from 'src/theme/universe/brand';
import FileCard from '../item/FileCard';

// ----------------------------------------------------------------------
// THE FILES OF A SHARED FOLDER: one sheet, one row per file, a hairline
// between them — a list to take files from, not a wall of cards (29/10/2026).

FileGridView.propTypes = {
  tableData: PropTypes.array
};

export default function FileGridView({ tableData = [] }) {
  const theme = useTheme();
  return (
    <Box component="ul" sx={{ ...regionSheetSx(theme), m: 0, p: 0, listStyle: 'none' }}>
      {tableData.map((file, index) => (
        // a stored file has no id of its own: its address, and its place in
        // the folder for the rare copy stored twice
        <Box
          component="li"
          key={`${file?.fileName}-${index}`}
          sx={{ minWidth: 0, ...(index > 0 && { borderTop: `1px solid ${hairlineOf(theme)}` }) }}
        >
          <FileCard file={file} />
        </Box>
      ))}
    </Box>
  );
}
